import { RecordListVariables } from "./record-list.variables";

export class RecordListFunctions {
    public variables: RecordListVariables;

    constructor(
        variables: RecordListVariables,
    ) {
        this.variables = variables;
    }
}
